
export enum ReplacementBracesRegime {
  noBraces,
  singleBraces,
  doubleBraces
}

export interface ReplacementOptions {
  braces?: ReplacementBracesRegime;
  replacePredicate?: true | false | Function;
}
